export default function parseEmail(email?: string) {
  return email?.replace(/^(.{0,4}).*@/, "$1***@")
}
